import { ChargerConfigurationBooleanField } from './components/fields/ChargerConfigurationBooleanField';
import { ChargerConfigurationCheckboxField } from './components/fields/ChargerConfigurationCheckboxField';
import { ChargerConfigurationRadioField } from './components/fields/ChargerConfigurationRadioField';
import { ChargerConfigurationSelectField } from './components/fields/ChargerConfigurationSelectField';
import ChargerConfigurationTextField from './components/fields/ChargerConfigurationTextField';

export const accessLevels = {
  readWrite: 'RW',
  readOnly: 'RO',
};

export const parameterStatuses = {
  LIVE: 'LIVE',
  MODIFIED: 'MODIFIED',
  REQUESTED: 'REQUESTED',
  REJECTED: 'REJECTED',
  APPLIED: 'APPLIED',
};

export const controllerTypes = {
  select: 'SELECT',
  multi_select: 'MULTI_SELECT',
  text_field: 'TEXT_FIELD',
  text_area: 'TEXT_AREA',
  number: 'NUMBER',
  radio: 'RADIO',
  checkbox: 'CHECKBOX',
  toggle: 'TOGGLE',
  date: 'DATE',
  date_range: 'DATE_RANGE',
};

export const statusesAssociatedWithRequestedValue = [parameterStatuses.REQUESTED, parameterStatuses.REJECTED, parameterStatuses.MODIFIED];

export const chargerConfigurationFormId = 'chargerConfigurationForm';

export const controllerTypeMap = {
  SELECT: ChargerConfigurationSelectField,
  MULTI_SELECT: ChargerConfigurationSelectField,

  TEXT_FIELD: ChargerConfigurationTextField,
  TEXT_AREA: ChargerConfigurationTextField,
  NUMBER: ChargerConfigurationTextField,
  string: ChargerConfigurationTextField,
  text: ChargerConfigurationTextField,

  RADIO: ChargerConfigurationRadioField,
  CHECKBOX: ChargerConfigurationCheckboxField,
  TOGGLE: ChargerConfigurationBooleanField,

  DATE: ChargerConfigurationTextField,
  DATE_RANGE: ChargerConfigurationTextField,
};

export const defaultGroupName = 'Miscellaneous Parameters';

export const toggleCurrentValueMap = {
  'true': 'On',
  'false': 'Off',
};
